import { now,  tomorrow, next_month } from "./datetime"
// import { STATE_ENUM } from "./consts"

/**
 * Inject values in `document.template` object
 * @param {*} template The `document.template` object to inject values in
 * @param {Array} fieldvalues The list of `document.fieldValues` to inject
 * @returns The document object with values
 */
function injectValues(template, fieldvalues) {
  let document = Object.assign({}, template)
  for (const section of document.sections) {
    for (const field of section.fields) {
      field.values = fieldvalues.find(e => e.field === field.id)?.values
    }
  }
  return document
}

/**
 * Create new empty `Invites` object
 * @returns The new invite
 */
function mkInvites() {
  return {
    email: "",
    errors: "",
    privileges: {
      inspector: false,
      operator: true
    }
  }
}


/**
 * MAKE/FACTORY METHODS
 **/

/**
 * Create new empty `NonConformity` object
 * @returns The new NonConformity
 */
function mkStaffMember() {
  return {
    last_name: "",
    matricule: "",
    first_name: "",
    email: "",
    image: null,
    phone_number: "",
    position: "",
    is_webuser: false,
    is_pro_mobile: false,
    monthly_limit: "",
    location_shop: null,
    department: null,
  }
}


/**
 * Create new empty `CompanyVehicle` object
 * @returns The new CompanyVehicle
 */
function mkCompanyVehicle() {
  return {
    registration_number: "",
    make: "",
    model: "",
    year: "",
    color: "",
    vin: "",
    image: null,
    monthly_limit: "",
    driver_last_name: "",
    driver_first_name: "", 
    driver_phone_number: "",
    product: null,
    vehicle_type: null,
    other_make: "",
    other_model: "", 
    carte_grise: null,
    reservoir_capacity: null,
    secret_code: '',
    department: null,
    is_all_used: false,
    is_kmh: false,
    can_take_picture: false
  }
}


/**
 * Create new empty `CompanyVoucher` object
 * @returns The new CompanyVoucher
 */
function mkCompanyVoucher() {
  return {
    vehicle: null,
    recipient_company: null,
    purchase_liters: "",
    bl_number: "",
    destination: "",
    purchase_amount: 0,
    valid_until: next_month(),
    company_shop: null,
    company_product: null,
    frequency: null,
    allow_successive: false,
    accumulate_remaining: false,
    is_all_money: false
  }
}

/**
 * Create new empty `InternalNotification` object
 * @returns The new InternalNotification
 */
function mkSpendingRequest() {
  return {
    vehicle: null,
    requested_amount: "",
    justification: "",
    lang: ""
  }
}

/**
 * Create new empty `Donation` object
 * @returns The new Donation
 */
function mkDonation() {
  return {
    company_shop: null,
    company_product: null,
    purchase_liters: "",
    purchase_amount: "",
    last_name: "",
    first_name: "",
    phone_number: "",
    valid_until: tomorrow(),
    // requested_amount: "",
    status: "",
  }
}

/**
 * Create new empty `InternalNotification` object
 * @returns The new InternalNotification
 */
function mkProduct() {
  return {
    name: "",
    price: ""
  }
}

/**
 * Create new empty `InternalNotification` object
 * @returns The new InternalNotification
 */
function mkCity() {
  return {
    name: "",
  }
}


/**
 * Create new empty `InternalNotification` object
 * @returns The new InternalNotification
 */
function mkMunicipality() {
  return {
    name: "",
    city: null
  }
}


/**
 * Create new empty `InternalNotification` object
 * @returns The new InternalNotification
 */
function mkShop() {
  return {
    name: "",
    address: "",
    longitude: "",
    latitude: "",
    description: "",
    city: null,
    municipality: null,
    shop_avalanche_id: "",
    restrict_visibility: false,
    allowed_recipient_companies: [],
  }
}

/**
 * Create new empty `PcqDsi` object
 * @returns The new PcqDsi
 */
function mkPartnerCard() {
  return {
    name: "",
    description: "",
    template: null,
    logo: null,
    captionImage: null
  }
}

/**
 * Create new empty `InternalNotification` object
 * @returns The new InternalNotification
 */
function mkCoupon() {
  return {
    code: "",
    discount_percentage: "",
    valid_from: now(),
    valid_until: tomorrow(),
  }
}

/**
 * Create new empty `InternalNotification` object
 * @returns The new InternalNotification
 */
function mkUserCoupon() {
  return {
    code: "",
  }
}

export {
  injectValues,
  mkCoupon,
  mkSpendingRequest,
  mkStaffMember,
  mkInvites,
  mkUserCoupon,
  mkPartnerCard,
  mkCompanyVehicle,
  mkProduct,
  mkShop,
  mkCompanyVoucher,
  mkCity,
  mkMunicipality,
  mkDonation
}
